<ion-grid>
    <ion-row>
        <ion-col size="12" class="align-center-items">
            <img src="assets/img/no-data-card-img.svg">
        </ion-col>
        <ion-col size="12" class="align-center-items">
            <p class="no-data-text description">
                {{ description | translate }}
            </p>
        </ion-col>
        <ion-col size="12" class="align-center-items">
            <p class="no-data-text subtitle">
                {{ subtitle | translate }}
            </p>
        </ion-col>
    </ion-row>
</ion-grid>
